module.exports = __webpack_public_path__ + "media/images/category/rank3-29b90eeed81a21a9a2a9aadfc66cda4b.gif";